import React, { useState } from 'react';
import FormField from '../../../table/modals/formField';
import { Dialog as MuiDialog, Stack, Typography } from '@mui/material';
import Button from '../../../ui/button';

const ErrorModal = ({ 
    fieldsConfig, 
    title,  
    onClose, 
    initialData, 
    onSave, 
    lineNumber
}) => {
    const [formData, setFormData] = useState(initialData[lineNumber]);
    const [loading, setLoading] = useState(false);

    const handleChange = ({ target: { id, value } }) => {
        setFormData((prev) => {
            const [section, field] = id.split(".");
            return { ...prev, [section]: { ...prev[section], [field]: value } };
        });
    };

    const handleMultiSelectChange = handleChange;

    const onSubmit = () => {
        setLoading(true);
        onSave(formData, lineNumber);
        setLoading(false);
        onClose();
    };

    const generateFormFields = (sectionFields) => {
        return sectionFields.map((fieldConfig) => {
            const [section, field] = (fieldConfig.id || '').split('.'); 
            const currentValue = formData?.[section]?.[field] || "";

            return (
                <FormField
                    key={fieldConfig.id}
                    onChange={fieldConfig.type !== "multi-select" ? handleChange : handleMultiSelectChange}
                    {...fieldConfig}
                    value={currentValue}
                />
            );
        });
    };

    return (
        <MuiDialog
            open={true}
            onClose={onClose}
            width="sm"
            fullWidth
            sx={{ '& .MuiDialog-paper': { padding: '2rem' } }}
        >
            <h1>{title || `Editing: ${formData?.["personalInfo"]?.["name"]?.value}`}</h1>
            <hr />
            {fieldsConfig.sections.map((section) => (
                <div key={section.section}>
                    <Typography variant="h5" sx={{ fontWeight: '600', mb: 0.5 }}>
                        {section.section}
                    </Typography>
                    <Stack spacing={2}>{generateFormFields(section.fields)}</Stack>
                    <br />
                </div>
            ))}
            <div className="sidepeek-footer">
                <Stack direction="row" justifyContent="flex-end" gap={1}>
                    <Button
                        variant="contained"
                        textColor="var(--black)"
                        bgColor="#F3F4F6"
                        size="small"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                    <Button variant="contained" size="small" onClick={onSubmit} disabled={loading}>
                        {loading ? "Saving..." : "Save Changes"}
                    </Button>
                </Stack>
            </div>
        </MuiDialog>
    );
};

export default ErrorModal;
